import React, { useEffect, useState } from "react";
import {
  BarChart,
  Bar,
  Cell,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";
import useSave from '../../Hooks/useSave'

const data = [
  {
    week: "1",
    count: 4000,
  },
  {
    week: "2",
    count: 3000,
    pv: 1398,
    amt: 2210,
  },
  {
    week: "3",
    count: 2000,
    pv: 9800,
    amt: 2290,
  },
  {
    week: "Page D",
    count: 2780,
    pv: 3908,
    amt: 2000,
  },
  {
    week: "Page E",
    count: 1890,
    pv: 4800,
    amt: 2181,
  },
  {
    week: "Page F",
    uv: 2390,
    pv: 3800,
    amt: 2500,
  },
  {
    week: "Page G",
    count: 3490,
    pv: 4300,
    amt: 2100,
  },
];

export default function PureComponent() {
  const { fetchGraphql } = useSave()

  const [weeks, setWeeks] = useState()

  useEffect(() => { 
    fetchGraphql({
      query:`query orderCount {
        orderCount {
          count
          week
          year
        }
      }`
    }).then(result => setWeeks(result.data.orderCount))
  }, [])
    return (
      <ResponsiveContainer width="100%" height="100%">
        <BarChart
          width={500}
          height={300}
          data={weeks}
          margin={{
            top: 5,
            right: 30,
            left: 20,
            bottom: 5,
          }}
        >
          <CartesianGrid strokeDasharray="3 3" />
          <XAxis dataKey="week" />
          <YAxis />
          <Tooltip />
          <Legend />
          <Bar dataKey="count" fill="#82ca9d" />
        </BarChart>
      </ResponsiveContainer>
    );
}
